





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { cloneDeep, isEqual } from 'lodash'

@Component
export default class CreatePhaseStatusFormStep3 extends Vue {
    @Prop({ required: true }) readonly value!: RealworksStatusRule
    editingValue: RealworksStatusRule = null

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
    }

    @Watch('editingValue.applyToTriggeredReferrals')
    @Watch('editingValue.applyToTriggeredReferralsPastDays')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    get applyToTriggeredReferrals() {
        if (this.value.triggerType === 'agendaTypes') {
            return this.$t('virtualColleague.phaseStatus.applyToTriggeredReferralsLabel', {event: 'afspraken'})
        } else if (this.value.triggerType === 'taakTypes') {
            return this.$t('virtualColleague.phaseStatus.applyToTriggeredReferralsLabel', {event: 'taken'})
        } else  {
            return this.$t('virtualColleague.phaseStatus.applyToTriggeredReferralsLabel', {event: 'kenmerken'})
        }
    }

    get phaseName() {
        return this.value?.phases
            .map(phase => phase.name)
            .join(', ')
    }

    get avatarHeaderText() {
        const values = {
            pipeline: this.value.pipeline.name,
            phase: this.phaseName,
            newStatus: this.value.toStatus,
            newPhase: this.value.toPhase?.name,
            newStatusReason: this.value.toNewStatusReason?.name,
        }

        if (this.value.toStatus === 'open') {
            if (this.value.toNewStatusReason !== null) {
                return this.$t('virtualColleague.phaseStatus.avatarHeader.stepThree.toPhaseWithReason', values)
            } else {
                return this.$t('virtualColleague.phaseStatus.avatarHeader.stepThree.toPhase', values)
            }
        } else {
            if (this.value.toNewStatusReason !== null) {
                return this.$t('virtualColleague.phaseStatus.avatarHeader.stepThree.toStatusWithReason', values)
            } else {
                return this.$t('virtualColleague.phaseStatus.avatarHeader.stepThree.toStatus', values)
            }
        }
    }

    get supportsTriggeredReferrals(): boolean {
        return true
    }

    get supportsTriggeredReferralsPastDays(): boolean {
        return ['agendaTypes', 'taakTypes'].includes(this.editingValue.triggerType)
    }
}
